import Helper from 'src/helpers';
import { messages } from 'src/constants/messages';
import { logOut } from 'src/util/Common';

export default (status) => {
  switch (status) {
    case 400:
      return Helper.alertError(messages.TRUNG_DU_LIEU);
    case 401:
      setTimeout(()=>{
        logOut();
      },3000)
      return Helper.alertError(messages.HET_PHIEN_LAM_VIEC);
    case 404:
      return Helper.alertError(messages.DICH_VU_KO_TON_TAI);
    case 409:
      return Helper.alertError(messages.NOI_DUNG_TRUNG_LAP);
    case 417:
      return Helper.alertError(messages.DU_LIEU_KO_TON_TAI);
    case 416:
      return Helper.alertError(messages.DU_LIEU_DANG_SU_DUNG);
    case 500:
      return Helper.alertError(messages.LOI_HE_THONG);
    case 504:
      return Helper.alertError(messages.KHONG_PHAN_HOI);
    default:
      break;
  }
}